import { GlobalState } from "little-state-machine";

export const updateUsername = (state: GlobalState, username: string | undefined) => ({
  ...state,
  username
});
